/**
 * Created by flj on 2019/3/26 .
 */
import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.less';

class Footer extends (PureComponent || Component) {
	render () {
		const prefixCls = 'eh-footer-component';
		const { children } = this.props;
		return (
			<div className={prefixCls}>
				{children}
			</div>
		);
	}
}

Footer.propTypes = {
	// 子节点
	children: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	])
};

export default Footer;
